import React from "react";

export default function TeamCard({ img, name, role }) {
  return (
    <div className="w-[380px] gap-3 px-3  border-white  border-2   h-[140px] items-center backdrop-blur-lg flex justify-between rounded-xl  bg-purple-300/10 text-white  ">
      <div className="w-[30%]">
        <img src={img} alt={name} className="rounded-full w-full     object-cover"/>
      </div>
      <div className="w-[70%] flex flex-col gap-2">
        <p className="font-poppins font-semibold text-[28px]">{name}</p>
        <div className="w-11/12 h-[2px] bg-gradient-to-r from-[#5f0062]  to-[#e670ea]"></div>
        <p className="font-poppins font-extralight text-sm bg-clip-text text-white bg-gradient-to-r  to-[#921196]">{role}</p>
      </div>
    </div>
  );
}
